import DocumentationList from "./DocumentationList.container";

export default DocumentationList;
